import { ReactNode } from "react";
import DataDisplayTabI from "./DataDisplayTabI";

abstract class DataDisplayTab implements DataDisplayTabI {

    reverseSortDirection: boolean;
    classes: { readonly [key: string]: string; };
    rows: JSX.Element[];

    constructor(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]) {
        this.reverseSortDirection = reverseSortDirection
        this.classes = classes
        this.rows = rows
    }

    abstract createTab(tab: string): ReactNode

}

export default DataDisplayTab
